import { type Currency } from '@lingoda/monolith-graphql';
import { CurrencyField as CurrencyFieldForms } from '@lingoda/forms';
import { usePaymentCurrencies } from '../hooks';

export interface CurrencyFieldProps {
    value?: Currency;
    onChange: (currency: Currency) => void;
    disabled?: boolean;
    fullWidth?: boolean;
}
export const CurrencyField = ({ value, onChange, disabled, fullWidth }: CurrencyFieldProps) => {
    const { defaultCurrency, currencies, error, loading } = usePaymentCurrencies();

    if (!currencies || error || loading) {
        return null;
    }

    return (
        <CurrencyFieldForms
            currency={value || defaultCurrency}
            currencies={currencies}
            onChange={onChange}
            disabled={disabled}
            fullWidth={fullWidth}
        />
    );
};
